/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import PrArticulationsCountedJournalEvent from "parog-web/models/pr-articulations-counted-journal-event";

import styles from "./index.module.css";

export default class ArticulationsEditionFormComponent extends JournalEventBasedComponent {
  styles = styles;

  static forcDisplayName = "Déclarer des mesures d'activité de la maladie";
  static fullComponentId = "das28/articulations-edition-form";

  /** @type { import("core/services/session").default } */
  @service session;

  static journalEventClass = PrArticulationsCountedJournalEvent;

  journalEventProperties = ["occurredAt", "nad", "nag"];

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  //Overrwite to enable save button with 0 articulations selected
  get isDirty() {
    return true;
  }

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.occurredAt = new Date();
      model.nad = [];
      model.nag = [];
    }
    return model;
  }
}
